<template slot-scope="props">
  <div class="animated fadeIn">
    
    <form>
      <b-row>
        <b-col sm="12">
          <b-card id="card-relatorio" 
            :bg-variant="isDark ? 'dark' : 'white'" 
            :text-variant="isDark ? 'light' : 'dark'"
            :footer-bg-variant="isDark ? 'dark' : 'light'">
             <div class="p-4 d-flex align-items-center justify-content-between" 
                  :class="isDark ? 'bg-secondary-soft' : 'bg-primary-soft'">
                <div>
                  <h4 class="mb-1 font-weight-bold" :class="isDark ? 'text-white' : 'text-primary'">
                    <i class='fa fa-file-text-o mr-2'></i>Relatório de Estoque
                  </h4>
                  <span class="text-muted d-block">Configure os filtros abaixo para gerar seu documento personalizado.</span>
                </div>
            </div>

            <!-- Seção 1: Tipo de Relatório -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-list-alt mr-2"></i>Tipo de Relatório</h6>
              <b-row>
                <b-col sm="12">
                  <b-form-group label-for="tipoRelatorio" description="Selecione o formato dos dados para o relatório." :class="isDark ? 'text-light' : ''">
                    <b-form-select 
                      id="tipoRelatorio"
                      v-model="tipoRelatorio"
                      :options="opcoesRelatorio"
                      :plain="true"
                      :class="isDark ? 'bg-secondary text-white border-info' : 'select-premium'"
                      class="form-control-lg"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 2: Filtros Principais -->
            <div class="section-container mb-4" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-filter mr-2"></i>Filtros Principais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group label="Centro Estoque">
                    <centro-estoque-drop-down
                      v-model="CENTRO_ESTOQUE_ID"
                      ref="centroEstoquePesquisa"
                      placeholder="Todos os centros de estoque"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group label="Grupo de Produto">
                    <grupo-produto-drop-down
                      v-model="GRUPO_PRODUTO_ID"
                      ref="grupoProdutoPesquisa"
                      placeholder="Todos os grupos de produto"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <!-- Seção 3: Configurações Adicionais -->
            <div class="section-container mb-2" :class="isDark ? 'dark-mode' : ''">
              <h6 class="section-title" :class="isDark ? 'dark-mode' : ''"><i class="fa fa-cog mr-2"></i>Configurações Adicionais</h6>
              <b-row>
                <b-col md="6" sm="12">
                  <b-form-group>
                    <b-form-checkbox 
                      v-model="exibirZerados" 
                      :value="true" 
                      :unchecked-value="false"
                      class="custom-checkbox-label">
                      <span class="font-weight-semibold">Exibir Zerados</span>
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                  <b-form-group>
                    <b-form-checkbox 
                      v-model="exibirValoresFinanceiros" 
                      :value="true" 
                      :unchecked-value="false"
                      class="custom-checkbox-label">
                      <span class="font-weight-semibold">Exibir Valores Financeiros</span>
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>

            <div class="card-footer-action p-4 text-center mt-2" :class="isDark ? 'bg-dark-darker' : 'bg-white'">
               <b-button size="lg" type="button" variant="primary" @click.stop.prevent="imprimir()" class="px-5 py-3 btn-pill shadow-lg btn-generate">
                  <i class="fa fa-print mr-2"></i> GERAR RELATÓRIO DE ESTOQUE
               </b-button>
            </div>

          </b-card>
          
        </b-col>
      </b-row>
    </form>
    
  </div>
</template>

<script>
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import CentroEstoqueDropDown from '../componentes/dropdown/CentroEstoqueDropDown.vue'
import GrupoProdutoDropDown from '../componentes/dropdown/GrupoProdutoDropDown.vue'
import RelatorioHTML from '../../utils/RelatorioHTML'
import tools from '../../tools/tools'
import { printGroupedHtmlReport } from '@/utils/RelatorioHTML'

export default {
  components: {
    VueButtonSpinner,
    CentroEstoqueDropDown,
    GrupoProdutoDropDown
  },
  data () {
    return {
      CENTRO_ESTOQUE_ID: null,
      GRUPO_PRODUTO_ID: null,
      exibirZerados: false,
      exibirValoresFinanceiros: false,
      tipoRelatorio: '1',
      opcoesRelatorio: [
        { value: '1', text: 'Peso e Peças Listagem Geral' },
        { value: '2', text: 'Peso e Peças Listagem Acumulado' },
        { value: '3', text: 'Peso e Peças Organizado por Grupo' },
        { value: '4', text: 'Peso e Peças Organizado por Centro Estoque' },
        { value: '5', text: 'Peso e Peças Mapa por Centro Estoque' },
        { value: '6', text: 'Etiquetas e Pesos Listagem Geral' },
        { value: '7', text: 'Etiquetas e Pesos Organizado por Grupo' },
        { value: '8', text: 'Etiquetas e Pesos Organizado por Centro de Estoque' },
        { value: '9', text: 'Etiquetas e Numero Listagem Geral' },
        { value: '10', text: 'Etiquetas e Numero Organizado por Grupo' },
        { value: '11', text: 'Etiquetas e Numero Organizado por Centro de Estoque' },
        { value: '12', text: 'Listagem Geral com Detalhe de Lotes' },
        { value: '13', text: 'Listagem Acumulada com Detalhe de Lotes' },
        { value: '14', text: 'Listagem Analítica de Lotes' },
        { value: '15', text: 'Listagem Sintética de Lotes' },
        { value: '16', text: 'Estoque de Etiquetas por Grupo' },
        { value: '17', text: 'Etiquetas por Vencimento' },
        { value: '18', text: 'Acumulado por Vencimento' },
        { value: '19', text: 'Previsão de Vencimento por Produto' },
        { value: '20', text: 'Previsão de Vencimento por Grupo' },
        { value: '21', text: 'Estoque de Etiquetas por Grupo com Custo' }
      ]
    }
  },
  methods: {
    getLabelFromDropDown (refName, value) {
      const component = this.$refs[refName]
      if (component && component.options) {
        const option = component.options.find(o => o.value === value)
        return option ? option.text : ''
      }
      return ''
    },
    imprimir () {
      if (this.tipoRelatorio === '12') {
        this.gerarRelatorioLotesHtml()
        return
      }
      if (this.tipoRelatorio === '13') {
        this.gerarRelatorioLotesAcumuladoHtml()
        return
      }
      if (this.tipoRelatorio === '14') {
        this.gerarRelatorioLotesAnaliticoHtml()
        return
      }
      if (this.tipoRelatorio === '15') {
        this.gerarRelatorioLotesSinteticoHtml()
        return
      }
      if (this.tipoRelatorio === '16') {
        this.gerarRelatorioEtiquetasGrupo()
        return
      }
      if (this.tipoRelatorio === '17') {
        this.gerarRelatorioEtiquetasVencimento()
        return
      }
      if (this.tipoRelatorio === '18') {
        this.gerarRelatorioAcumuladoVencimento()
        return
      }
      if (this.tipoRelatorio === '19') {
        this.gerarRelatorioPrevisaoVencimentoProduto()
        return
      }
      if (this.tipoRelatorio === '20') {
        this.gerarRelatorioPrevisaoVencimentoGrupo()
        return
      }
      if (this.tipoRelatorio === '21') {
        this.gerarRelatorioEtiquetasGrupoComCusto()
        return
      }
      this.$store.commit('controle/setAguardando', true)
      this.isLoading = true

      const params = {
        centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
        lbCentroEstoque: this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID),
        grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
        lbGrupoProduto: this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID),
        exibirZerados: this.exibirZerados ? '1' : '0',
        exibirValoresFinanceiros: this.exibirValoresFinanceiros ? '1' : '0',
        lbEmpresa: window.localStorage.getItem('nomeempresa') || '',
        lbUsuario: window.localStorage.getItem('nomeusuario') || '',
        tipoRel: this.tipoRelatorio
      }

      const uri = '/api/protected/relatorios/estoque?' + new URLSearchParams(params).toString()
        
      this.$http.get(uri, {responseType: 'arraybuffer'})
      .then(response => {
        this.$store.commit('controle/setAguardando', false)
        this.$root.$bvToast.toast('Relatório Gerado com Sucesso!', {
          title: 'Sucesso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'relEstoque.pdf') 
        link.download = 'RelEstoque.pdf'
        
        const janela = window.open(link)
        janela.onload = function(){
          setTimeout(() => {
            janela.document.title = 'Relatório de Estoque'
          }, 2000);
        }
        this.$store.commit('controle/setAguardando', false)
      })
      .catch(erro => {
        this.$toast.error({
          title: 'Erro',
          message: 'Ocorreram erros ao gerar o Relatório',
          progressBar: false,
          showMethod: 'shake',
          position: 'top full width'
        })
        this.$store.commit('controle/setAguardando', false)
      })
    },

    

    async gerarRelatorioEtiquetasGrupo() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueEtiquetasPorGrupo', { params })
        
        printGroupedHtmlReport({
          rows: data,
          columns: [
            { key: 'NUMERO_CAIXA', label: 'Caixa', width: '6%' },
            { key: 'LOTE', label: 'Lote', width: '10%' },
            { key: 'LOTE_FORNECEDOR', label: 'L. Fornec.', width: '10%' },
            { key: 'CODIGO_BARRAS', label: 'Cód. Barras', width: '15%' },
            { key: 'PESO', label: 'Peso(KG)', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '8%', align: 'right' },
            { key: 'PECAS', label: 'Peças', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '6%', align: 'right' },
            { key: 'VALIDADE', label: 'Validade', type: 'date', formatter: (val) => tools.formatarDataBR(val), width: '9%', align: 'center' },
            { key: 'NOME_FORNECEDOR', label: 'Fornecedor', width: '36%' }
          ],
          groupBy: { key: 'NOME_GRUPO' },
          sumKeys: ['PESO', 'PECAS'],
          reportTitle: 'Estoque de Etiquetas por Grupo',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: true,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioEtiquetasGrupoComCusto() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueEtiquetasPorGrupoComCusto', { params })

        printGroupedHtmlReport({
          rows: data,
          columns: [
            { key: 'NUMERO_CAIXA', label: 'Caixa', width: '6%' },
            { key: 'NOME_PRODUTO', label: 'Produto', width: '15%' },
            { key: 'LOTE', label: 'Lote', width: '8%' },
            { key: 'LOTE_FORNECEDOR', label: 'L. Fornec.', width: '8%' },
            { key: 'CODIGO_BARRAS', label: 'Cód. Barras', width: '13%' },
            { key: 'PESO', label: 'Peso Liquido', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PESO_BRUTO', label: 'Peso Bruto', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'QTDE_ETIQUETAS', label: 'Etiq.', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '4%', align: 'right' },
            { key: 'PECAS', label: 'Peças', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'VL_CUSTO_UNITARIO', label: 'Custo Unit.', type: 'currency', formatter: (val) => tools.formatCurrency(Number(val || 0)), width: '9%', align: 'right' },
            { key: 'VL_CUSTO_TOTAL', label: 'Custo Total', type: 'currency', formatter: (val) => tools.formatCurrency(Number(val || 0)), width: '9%', align: 'right' },
            { key: 'VALIDADE', label: 'Validade', type: 'date', formatter: (val) => tools.formatarDataBR(val), width: '8%', align: 'center' },
            { key: 'NOME_FORNECEDOR', label: 'Fornecedor', width: '9%' }
          ],
          groupBy: { key: 'NOME_GRUPO' },
          sumKeys: ['PESO', 'PESO_BRUTO', 'QTDE_ETIQUETAS', 'PECAS', 'VL_CUSTO_UNITARIO', 'VL_CUSTO_TOTAL'],
          reportTitle: 'Estoque de Etiquetas por Grupo com Custo',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: true,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioEtiquetasVencimento() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueEtiquetasPorVencimento', { params })
        
        // Formatar validade para agrupar corretamente
        const rows = data.map(d => ({
          ...d,
          GRUPO_VENCIMENTO: tools.formatarDataBR(d.VALIDADE) || 'Sem Vencimento'
        }))

        printGroupedHtmlReport({
          rows,
          columns: [
            { key: 'NUMERO_CAIXA', label: 'Caixa', width: '6%' },
            { key: 'NOME_PRODUTO', label: 'Produto', width: '25%' },
            { key: 'LOTE', label: 'Lote', width: '10%' },
            { key: 'LOTE_FORNECEDOR', label: 'L. Fornec.', width: '10%' },
            { key: 'CODIGO_BARRAS', label: 'Cód. Barras', width: '15%' },
            { key: 'PESO', label: 'Peso(KG)', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '8%', align: 'right' },
            { key: 'PECAS', label: 'Peças', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '6%', align: 'right' },
            { key: 'NOME_FORNECEDOR', label: 'Fornecedor', width: '20%' }
          ],
          groupBy: { key: 'GRUPO_VENCIMENTO' },
          sumKeys: ['PESO', 'PECAS'],
          reportTitle: 'Etiquetas por Vencimento',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: true,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioAcumuladoVencimento() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueAcumuladoPorVencimento', { params })
        
        const rows = data.map(d => ({
          ...d,
          GRUPO_VENCIMENTO: tools.formatarDataBR(d.VALIDADE) || 'Sem Vencimento'
        }))

        printGroupedHtmlReport({
          rows,
          columns: [
            { key: 'PRODUTO_ID', label: 'Código', width: '10%' },
            { key: 'NOME_PRODUTO', label: 'Descrição', width: '60%' },
            { key: 'PESO', label: 'Peso(KG)', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '15%', align: 'right' },
            { key: 'PECAS', label: 'Peças', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '15%', align: 'right' }
          ],
          groupBy: { key: 'GRUPO_VENCIMENTO' },
          sumKeys: ['PESO', 'PECAS'],
          reportTitle: 'Acumulado por Vencimento',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: false,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioPrevisaoVencimentoProduto() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoquePrevisaoVencimentoProduto', { params })

        printGroupedHtmlReport({
          rows: data,
          columns: [
            { key: 'PRODUTO_ID', label: 'Código', width: '5%' },
            { key: 'NOME_PRODUTO', label: 'Descrição', width: '23%' },
            { key: 'PESO_10', label: 'Peso 10d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_10', label: 'Pçs 10d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_20', label: 'Peso 20d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_20', label: 'Pçs 20d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_30', label: 'Peso 30d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_30', label: 'Pçs 30d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_45', label: 'Peso 45d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_45', label: 'Pçs 45d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_60', label: 'Peso 60d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_60', label: 'Pçs 60d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'TOTAL_PESO', label: 'Tot Peso', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'TOTAL_PECAS', label: 'Tot Pçs', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' }
          ],
          groupBy: { key: 'NOME_GRUPO' },
          sumKeys: ['PESO_10', 'PECAS_10', 'PESO_20', 'PECAS_20', 'PESO_30', 'PECAS_30', 'PESO_45', 'PECAS_45', 'PESO_60', 'PECAS_60', 'TOTAL_PESO', 'TOTAL_PECAS'],
          reportTitle: 'Previsão de Vencimento por Produto',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: true,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioPrevisaoVencimentoGrupo() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || ''
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoquePrevisaoVencimentoGrupo', { params })

        printGroupedHtmlReport({
          rows: data,
          columns: [
            { key: 'GRUPO_ID', label: 'Código', width: '10%' },
            { key: 'NOME_GRUPO', label: 'Grupo', width: '18%' },
            { key: 'PESO_10', label: 'Peso 10d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_10', label: 'Pçs 10d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_20', label: 'Peso 20d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_20', label: 'Pçs 20d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_30', label: 'Peso 30d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_30', label: 'Pçs 30d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_45', label: 'Peso 45d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_45', label: 'Pçs 45d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'PESO_60', label: 'Peso 60d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'PECAS_60', label: 'Pçs 60d', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' },
            { key: 'TOTAL_PESO', label: 'Tot Peso', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 3), width: '7%', align: 'right' },
            { key: 'TOTAL_PECAS', label: 'Tot Pçs', type: 'number', formatter: (val) => tools.formatarQuantidade(val, 0), width: '5%', align: 'right' }
          ],
          groupBy: null,
          sumKeys: ['PESO_10', 'PECAS_10', 'PESO_20', 'PECAS_20', 'PESO_30', 'PECAS_30', 'PESO_45', 'PECAS_45', 'PESO_60', 'PECAS_60', 'TOTAL_PESO', 'TOTAL_PECAS'],
          reportTitle: 'Previsão de Vencimento por Grupo',
          observations: 'Centro de Estoque: ' + (this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'Todos') + '\nGrupo de Produto: ' + (this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'Todos'),
          printedBy: window.localStorage.getItem('nomeusuario') || '',
          systemName: window.localStorage.getItem('nomeempresa') || '',
          landscape: true,
          autoPrint: true
        })
      } catch (e) {
        this.$root.$bvToast.toast('Erro ao buscar dados do relatório.', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },


    async gerarRelatorioLotesHtml() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
          exibirZerados: this.exibirZerados ? '1' : '0'
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueLotesHtml', { params })
        
        let totalPeso = 0
        let totalPecas = 0
        let totalReservado = 0
        let totalDisponivel = 0
        let totalCusto = 0

        data.forEach(p => {
          const reservado = p.RESERVADO || 0
          totalPeso += (p.PESO || 0)
          totalPecas += (p.PECAS || 0)
          totalReservado += reservado
          totalDisponivel += ((p.PESO || 0) - reservado)
          totalCusto += (p.CUSTO_RS || 0)
        })

        const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
        const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
        const dataHora = new Date().toLocaleString('pt-BR')

        const html = `
          <!doctype html>
          <html lang="pt-BR">
          <head>
            <meta charset="utf-8">
            <style>
              @page { size: A4 landscape; margin: 10mm; }
              body { font-family: 'Tahoma', sans-serif; margin: 0; color: #000; font-size: 9px; }
              
              /* Cabeçalho Estilo Espelho */
              .report-header { border: 1px solid #000; margin-bottom: 10px; }
              .header-top { display: flex; justify-content: space-between; padding: 3px 8px; border-bottom: 1px solid #000; font-weight: bold; background: #f2f2f2; }
              .header-title { padding: 5px 8px; font-size: 11px; font-weight: bold; text-align: center; text-transform: uppercase; }
              .header-sub { display: flex; justify-content: space-between; padding: 3px 8px; border-top: 1px solid #000; font-size: 8px; }
              
              /* Grid Principal */
              .grid-main { width: 100%; border-collapse: collapse; margin-top: 5px; }
              .grid-main th { background: #f2f2f2; border: 1px solid #000; padding: 4px; font-size: 9px; text-transform: uppercase; }
              .grid-main td { border: 1px solid #000; padding: 3px 5px; font-size: 9px; }
              .row-produto { background: #fafafa; font-weight: bold; }
              
              /* Grid de Lotes */
              .grid-lote { width: 100%; border-collapse: collapse; background: #fff; margin: 2px 0; }
              .grid-lote th { background: #fff; border: 0.5px solid #666; padding: 2px; font-size: 8px; color: #333; }
              .grid-lote td { border: 0.5px solid #aaa; padding: 2px; font-size: 8px; color: #444; font-weight: normal; }
              
              /* Totais */
              .footer-summary { margin-top: 5px; font-weight: bold; }
              .summary-table { width: 100%; border-collapse: collapse; border: 1px solid #000; }
              .summary-table td { padding: 4px 5px; background: #f2f2f2; }

              /* Rodapé Fixo Estilo Jasper */
              .report-footer { 
                position: fixed; 
                bottom: 0; 
                left: 0; 
                right: 0; 
                border-top: 1px solid #000; 
                padding-top: 4px; 
                display: flex; 
                justify-content: space-between; 
                font-size: 8px; 
                background: #fff;
              }

              @media print {
                .no-print { display: none; }
                body { margin: 0; }
                .report-footer { position: fixed; bottom: 0; }
              }
            </style>
          </head>
          <body>
            <!-- Cabeçalho Repetível -->
            <div class="report-header">
              <div class="header-top">
                <div>${nomeEmpresa}</div>
                <div>Usuário: ${nomeUsuario}</div>
              </div>
              <div class="header-title">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM GERAL COM DETALHE DE LOTES</div>
              <div class="header-sub">
                <div><strong>Filtros:</strong> Centro: ${this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'TODOS'} | Grupo: ${this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'TODOS'}</div>
                <div>Emitido em: ${dataHora}</div>
              </div>
            </div>

            <table class="grid-main">
              <thead>
                <tr>
                  <th width="60">CÓDIGO</th>
                  <th>DESCRIÇÃO DO PRODUTO</th>
                  <th width="60">UND COM.</th>
                  <th width="120">CENTRO ESTOQUE</th>
                  <th width="80" align="right">QUANTIDADE</th>
                  <th width="80" align="right">RESERVADO</th>
                  <th width="80" align="right">DISPONÍVEL</th>
                  <th width="70" align="right">MÉDIA</th>
                  <th width="90" align="right">CUSTO R$</th>
                </tr>
              </thead>
              <tbody>
                ${data.map(p => {
                  const reservado = p.RESERVADO || 0
                  const disponivel = (p.PESO || 0) - reservado
                  let row = `
                    <tr class="row-produto">
                      <td align="center">${p.COD_PRO}</td>
                      <td>${p.DESCRICAO}</td>
                      <td align="center">${p.ID_UNIDADE_COMERCIAL || '-'}</td>
                      <td>${p.NOME_CENTRO || '-'}</td>
                      <td align="right">${tools.formatarQuantidade(p.PESO)}</td>
                      <td align="right">${tools.formatarQuantidade(reservado)}</td>
                      <td align="right">${tools.formatarQuantidade(disponivel)}</td>
                      <td align="right">${tools.formatCurrency(p.MEDIA)}</td>
                      <td align="right">${tools.formatCurrency(p.CUSTO_RS)}</td>
                    </tr>
                  `
                  if (p.LOTES && p.LOTES.length > 0) {
                    row += `
                      <tr>
                        <td colspan="9" style="padding: 0 0 5px 30px; border-top: 0;">
                          <table class="grid-lote">
                            <thead>
                              <tr>
                                <th width="150">LOTE</th>
                                <th width="100">FABRICAÇÃO</th>
                                <th width="100">VALIDADE</th>
                                <th width="100" align="right">QUANTIDADE</th>
                              </tr>
                            </thead>
                            <tbody>
                              ${p.LOTES.map(l => `
                                <tr>
                                  <td>${l.LOTE}</td>
                                  <td align="center">${tools.formatarDataBR(l.DATA_FABRICACAO)}</td>
                                  <td align="center" style="${!l.DATA_VALIDADE ? 'color: #999;' : ''}">${tools.formatarDataBR(l.DATA_VALIDADE) || 'N/A'}</td>
                                  <td align="right">${tools.formatarQuantidade(l.QUANT_SALDO)}</td>
                                </tr>
                              `).join('')}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    `
                  }
                  return row
                }).join('')}
              </tbody>
              <tfoot>
                <tr style="background: #f2f2f2; font-weight: bold;">
                  <td colspan="4" align="right">TOTAL PRODUTOS: ${data.length} | TOTAIS GERAIS:</td>
                  <td align="right">${tools.formatarQuantidade(totalPeso)}</td>
                  <td align="right">${tools.formatarQuantidade(totalReservado)}</td>
                  <td align="right">${tools.formatarQuantidade(totalDisponivel)}</td>
                  <td></td>
                  <td align="right">${tools.formatCurrency(totalCusto)}</td>
                </tr>
              </tfoot>
            </table>

            <!-- Rodapé Estilo Jasper -->
            <div class="report-footer">
              <div>Impresso em: ${dataHora}</div>
              <div style="text-transform: uppercase;">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM GERAL</div>
              <div>Usuário: ${nomeUsuario}</div>
            </div>
          </body>
          </html>
        `
        RelatorioHTML.imprimir(html, 'Relatório de Posição de Estoque - Lotes', 'A4', 'landscape')
      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioLotesAcumuladoHtml() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
          exibirZerados: this.exibirZerados ? '1' : '0'
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueLotesAcumuladoHtml', { params })
        
        let totalPeso = 0
        let totalPecas = 0
        let totalReservado = 0
        let totalDisponivel = 0
        let totalCusto = 0

        data.forEach(p => {
          const reservado = p.RESERVADO || 0
          totalPeso += (p.PESO || 0)
          totalPecas += (p.PECAS || 0)
          totalReservado += reservado
          totalDisponivel += ((p.PESO || 0) - reservado)
          totalCusto += (p.CUSTO_RS || 0)
        })

        const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
        const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
        const dataHora = new Date().toLocaleString('pt-BR')

        const html = `
          <!doctype html>
          <html lang="pt-BR">
          <head>
            <meta charset="utf-8">
            <style>
              @page { size: A4 landscape; margin: 10mm; }
              body { font-family: 'Tahoma', sans-serif; margin: 0; color: #000; font-size: 9px; }
              .report-header { border: 1px solid #000; margin-bottom: 10px; }
              .header-top { display: flex; justify-content: space-between; padding: 3px 8px; border-bottom: 1px solid #000; font-weight: bold; background: #f2f2f2; }
              .header-title { padding: 5px 8px; font-size: 11px; font-weight: bold; text-align: center; text-transform: uppercase; }
              .header-sub { display: flex; justify-content: space-between; padding: 3px 8px; border-top: 1px solid #000; font-size: 8px; }
              .grid-main { width: 100%; border-collapse: collapse; margin-top: 5px; }
              .grid-main th { background: #f2f2f2; border: 1px solid #000; padding: 4px; font-size: 9px; text-transform: uppercase; }
              .grid-main td { border: 1px solid #000; padding: 3px 5px; font-size: 9px; }
              .row-produto { background: #eef3f7; font-weight: bold; }
              .row-centro-header { background: #f9f9f9; font-weight: bold; color: #125a70; font-size: 8px; }
              .grid-lote { width: 100%; border-collapse: collapse; background: #fff; margin: 1px 0; }
              .grid-lote th { background: #fff; border: 0.5px solid #aaa; padding: 2px; font-size: 8px; color: #333; }
              .grid-lote td { border: 0.5px solid #eee; padding: 2px; font-size: 8px; color: #444; font-weight: normal; }
              .footer-summary { margin-top: 5px; font-weight: bold; }
              .summary-table { width: 100%; border-collapse: collapse; border: 1px solid #000; }
              .summary-table td { padding: 4px 5px; background: #f2f2f2; }
              .report-footer { position: fixed; bottom: 0; left: 0; right: 0; border-top: 1px solid #000; padding-top: 4px; display: flex; justify-content: space-between; font-size: 8px; background: #fff; }
              @media print { .no-print { display: none; } body { margin: 0; } .report-footer { position: fixed; bottom: 0; } }
            </style>
          </head>
          <body>
            <div class="report-header">
              <div class="header-top">
                <div>${nomeEmpresa}</div>
                <div>Usuário: ${nomeUsuario}</div>
              </div>
              <div class="header-title">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM ACUMULADA COM DETALHE DE LOTES</div>
              <div class="header-sub">
                <div><strong>Filtros:</strong> Acumulado Geral | Grupo: ${this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'TODOS'}</div>
                <div>Emitido em: ${dataHora}</div>
              </div>
            </div>

            <table class="grid-main">
              <thead>
                <tr>
                  <th width="60">CÓDIGO</th>
                  <th>DESCRIÇÃO DO PRODUTO (TOTAL ACUMULADO)</th>
                  <th width="60">UND COM.</th>
                  <th width="80" align="right">QUANTIDADE</th>
                  <th width="80" align="right">RESERVADO</th>
                  <th width="80" align="right">DISPONÍVEL</th>
                  <th width="70" align="right">MÉDIA</th>
                  <th width="90" align="right">VALOR ESTOQUE</th>
                </tr>
              </thead>
              <tbody>
                ${data.map(p => {
                  const reservado = p.RESERVADO || 0
                  const disponivel = (p.PESO || 0) - reservado
                  
                  // Agrupar lotes por centro
                  const lotesPorCentro = {}
                  if (p.LOTES) {
                    p.LOTES.forEach(l => {
                      if (!lotesPorCentro[l.NOME_CENTRO]) lotesPorCentro[l.NOME_CENTRO] = []
                      lotesPorCentro[l.NOME_CENTRO].push(l)
                    })
                  }

                  let row = `
                    <tr class="row-produto">
                      <td align="center">${p.COD_PRO}</td>
                      <td>${p.DESCRICAO}</td>
                      <td align="center">${p.ID_UNIDADE_COMERCIAL || '-'}</td>
                      <td align="right">${tools.formatarQuantidade(p.PESO)}</td>
                      <td align="right">${tools.formatarQuantidade(reservado)}</td>
                      <td align="right">${tools.formatarQuantidade(disponivel)}</td>
                      <td align="right">${tools.formatCurrency(p.MEDIA)}</td>
                      <td align="right">${tools.formatCurrency(p.CUSTO_RS)}</td>
                    </tr>
                  `
                  
                  Object.keys(lotesPorCentro).forEach(centro => {
                    row += `
                      <tr class="row-centro-header">
                        <td colspan="8" style="padding-left: 20px;"><i class="fa fa-building mr-1"></i> CENTRO: ${centro}</td>
                      </tr>
                      <tr>
                        <td colspan="8" style="padding: 0 0 5px 40px; border-top: 0;">
                          <table class="grid-lote">
                            <thead>
                              <tr>
                                <th width="150">LOTE</th>
                                <th width="100">FABRICAÇÃO</th>
                                <th width="100">VALIDADE</th>
                                <th width="100" align="right">QUANTIDADE</th>
                              </tr>
                            </thead>
                            <tbody>
                              ${lotesPorCentro[centro].map(l => `
                                <tr>
                                  <td>${l.LOTE}</td>
                                  <td align="center">${tools.formatarDataBR(l.DATA_FABRICACAO)}</td>
                                  <td align="center">${tools.formatarDataBR(l.DATA_VALIDADE) || 'N/A'}</td>
                                  <td align="right">${tools.formatarQuantidade(l.QUANT_SALDO)}</td>
                                </tr>
                              `).join('')}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    `
                  })

                  return row
                }).join('')}
              </tbody>
              <tfoot>
                <tr style="background: #f2f2f2; font-weight: bold;">
                  <td colspan="3" align="right">TOTAL PRODUTOS: ${data.length} | TOTAIS GERAIS:</td>
                  <td align="right">${tools.formatarQuantidade(totalPeso)}</td>
                  <td align="right">${tools.formatarQuantidade(totalReservado)}</td>
                  <td align="right">${tools.formatarQuantidade(totalDisponivel)}</td>
                  <td></td>
                  <td align="right">${tools.formatCurrency(totalCusto)}</td>
                </tr>
              </tfoot>
            </table>

            <div class="report-footer">
              <div>Impresso em: ${dataHora}</div>
              <div style="text-transform: uppercase;">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM ACUMULADA</div>
              <div>Usuário: ${nomeUsuario}</div>
            </div>
          </body>
          </html>
        `
        RelatorioHTML.imprimir(html, 'Relatório de Posição de Estoque - Lotes Acumulado', 'A4', 'landscape')
      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioLotesAnaliticoHtml() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
          exibirZerados: this.exibirZerados ? '1' : '0'
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueLotesAnaliticoHtml', { params })
        
        let totalPeso = 0
        let totalPecas = 0
        let totalReservado = 0
        let totalDisponivel = 0
        let totalCusto = 0

        data.forEach(p => {
          const reservado = p.RESERVADO || 0
          totalPeso += (p.PESO || 0)
          totalPecas += (p.PECAS || 0)
          totalReservado += reservado
          totalDisponivel += ((p.PESO || 0) - reservado)
          totalCusto += (p.CUSTO_RS || 0)
        })

        const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
        const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
        const dataHora = new Date().toLocaleString('pt-BR')

        const html = `
          <!doctype html>
          <html lang="pt-BR">
          <head>
            <meta charset="utf-8">
            <style>
              @page { size: A4 landscape; margin: 10mm; }
              body { font-family: 'Tahoma', sans-serif; margin: 0; color: #000; font-size: 9px; }
              .report-header { border: 1px solid #000; margin-bottom: 10px; }
              .header-top { display: flex; justify-content: space-between; padding: 3px 8px; border-bottom: 1px solid #000; font-weight: bold; background: #f2f2f2; }
              .header-title { padding: 5px 8px; font-size: 11px; font-weight: bold; text-align: center; text-transform: uppercase; }
              .header-sub { display: flex; justify-content: space-between; padding: 3px 8px; border-top: 1px solid #000; font-size: 8px; }
              .grid-main { width: 100%; border-collapse: collapse; margin-top: 5px; }
              .grid-main th { background: #f2f2f2; border: 1px solid #000; padding: 4px; font-size: 9px; text-transform: uppercase; }
              .grid-main td { border: 1px solid #000; padding: 3px 5px; font-size: 9px; }
              .row-produto { background: #fafafa; font-weight: bold; }
              .grid-lote { width: 100%; border-collapse: collapse; background: #fff; margin: 2px 0; }
              .grid-lote th { background: #fff; border: 0.5px solid #666; padding: 2px; font-size: 8px; color: #333; }
              .grid-lote td { border: 0.5px solid #aaa; padding: 2px; font-size: 8px; color: #444; font-weight: normal; }
              .badge-vencido { background: #ff4d4d; color: #fff; padding: 1px 3px; border-radius: 3px; font-weight: bold; }
              .badge-critico { background: #ffcc00; color: #000; padding: 1px 3px; border-radius: 3px; font-weight: bold; }
              .footer-summary { margin-top: 5px; font-weight: bold; }
              .summary-table { width: 100%; border-collapse: collapse; border: 1px solid #000; }
              .summary-table td { padding: 4px 5px; background: #f2f2f2; }
              .report-footer { position: fixed; bottom: 0; left: 0; right: 0; border-top: 1px solid #000; padding-top: 4px; display: flex; justify-content: space-between; font-size: 8px; background: #fff; }
              @media print { .no-print { display: none; } body { margin: 0; } .report-footer { position: fixed; bottom: 0; } }
            </style>
          </head>
          <body>
            <div class="report-header">
              <div class="header-top">
                <div>${nomeEmpresa}</div>
                <div>Usuário: ${nomeUsuario}</div>
              </div>
              <div class="header-title">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM ANALÍTICA DE LOTES</div>
              <div class="header-sub">
                <div><strong>Filtros:</strong> Centro: ${this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'TODOS'} | Grupo: ${this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'TODOS'}</div>
                <div>Emitido em: ${dataHora}</div>
              </div>
            </div>

            <table class="grid-main">
              <thead>
                <tr>
                  <th width="60">CÓDIGO</th>
                  <th>DESCRIÇÃO DO PRODUTO</th>
                  <th width="60">UND COM.</th>
                  <th width="120">CENTRO ESTOQUE</th>
                  <th width="80" align="right">QUANTIDADE</th>
                  <th width="80" align="right">RESERVADO</th>
                  <th width="80" align="right">DISPONÍVEL</th>
                  <th width="70" align="right">MÉDIA</th>
                  <th width="90" align="right">CUSTO R$</th>
                </tr>
              </thead>
              <tbody>
                ${data.map(p => {
                  const reservado = p.RESERVADO || 0
                  const disponivel = (p.PESO || 0) - reservado
                  let row = `
                    <tr class="row-produto">
                      <td align="center">${p.COD_PRO}</td>
                      <td>${p.DESCRICAO}</td>
                      <td align="center">${p.ID_UNIDADE_COMERCIAL || '-'}</td>
                      <td>${p.NOME_CENTRO || '-'}</td>
                      <td align="right">${tools.formatarQuantidade(p.PESO)}</td>
                      <td align="right">${tools.formatarQuantidade(reservado)}</td>
                      <td align="right">${tools.formatarQuantidade(disponivel)}</td>
                      <td align="right">${tools.formatCurrency(p.MEDIA)}</td>
                      <td align="right">${tools.formatCurrency(p.CUSTO_RS)}</td>
                    </tr>
                  `
                  if (p.LOTES && p.LOTES.length > 0) {
                    row += `
                      <tr>
                        <td colspan="9" style="padding: 0 0 5px 30px; border-top: 0;">
                          <table class="grid-lote">
                            <thead>
                              <tr>
                                <th width="100">LOTE</th>
                                <th width="100">LOTE FORNEC.</th>
                                <th width="80">FABRICAÇÃO</th>
                                <th width="80">VALIDADE</th>
                                <th width="90">DIAS VENCER</th>
                                <th width="90" align="right">QUANTIDADE</th>
                                <th width="100">ORIGEM</th>
                              </tr>
                            </thead>
                            <tbody>
                              ${p.LOTES.map(l => {
                                let classeVencimento = ''
                                if (l.DIAS_VENCER !== null) {
                                  if (l.DIAS_VENCER < 0) classeVencimento = 'badge-vencido'
                                  else if (l.DIAS_VENCER < 30) classeVencimento = 'badge-critico'
                                }
                                
                                const origem = l.PRD_FORM_PROC_ID ? `PROC: ${l.PRD_FORM_PROC_ID}` : (l.PEDIDO_COMPRA_ID ? `PED: ${l.PEDIDO_COMPRA_ID}` : '-')

                                return `
                                  <tr>
                                    <td>${l.LOTE}</td>
                                    <td>${l.LOTE_FORNECEDOR || '-'}</td>
                                    <td align="center">${tools.formatarDataBR(l.DATA_FABRICACAO)}</td>
                                    <td align="center">${tools.formatarDataBR(l.DATA_VALIDADE) || 'N/A'}</td>
                                    <td align="center">
                                      <span class="${classeVencimento}">${l.DIAS_VENCER !== null ? l.DIAS_VENCER : '-'}</span>
                                    </td>
                                    <td align="right">${tools.formatarQuantidade(l.QUANT_SALDO)}</td>
                                    <td align="center" style="font-size: 7px;">${origem}</td>
                                  </tr>
                                `
                              }).join('')}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    `
                  }
                  return row
                }).join('')}
              </tbody>
              <tfoot>
                <tr style="background: #f2f2f2; font-weight: bold;">
                  <td colspan="4" align="right">TOTAL PRODUTOS: ${data.length} | TOTAIS GERAIS:</td>
                  <td align="right">${tools.formatarQuantidade(totalPeso)}</td>
                  <td align="right">${tools.formatarQuantidade(totalReservado)}</td>
                  <td align="right">${tools.formatarQuantidade(totalDisponivel)}</td>
                  <td></td>
                  <td align="right">${tools.formatCurrency(totalCusto)}</td>
                </tr>
              </tfoot>
            </table>

            <div class="report-footer">
              <div>Impresso em: ${dataHora}</div>
              <div style="text-transform: uppercase;">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM ANALÍTICA</div>
              <div>Usuário: ${nomeUsuario}</div>
            </div>
          </body>
          </html>
        `
        RelatorioHTML.imprimir(html, 'Relatório de Posição de Estoque - Analítico', 'A4', 'landscape')
      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async gerarRelatorioLotesSinteticoHtml() {
      this.$store.commit('controle/setAguardando', true)
      try {
        const params = {
          centroEstoqueId: this.CENTRO_ESTOQUE_ID || '',
          grupoProdutoId: this.GRUPO_PRODUTO_ID || '',
          exibirZerados: this.exibirZerados ? '1' : '0'
        }
        const { data } = await this.$http.get('/api/protected/estoque/getRelatorioEstoqueLotesSinteticoHtml', { params })
        
        let totalPeso = 0
        let totalPecas = 0

        data.forEach(l => {
          totalPeso += (l.PESO || 0)
          totalPecas += (l.PECAS || 0)
        })

        const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
        const nomeEmpresa = window.localStorage.getItem('nomeempresa') || 'CECWEB'
        const dataHora = new Date().toLocaleString('pt-BR')

        const html = `
          <!doctype html>
          <html lang="pt-BR">
          <head>
            <meta charset="utf-8">
            <style>
              @page { size: A4 portrait; margin: 10mm; }
              body { font-family: 'Tahoma', sans-serif; margin: 0; color: #000; font-size: 9px; }
              .report-header { border: 1px solid #000; margin-bottom: 10px; }
              .header-top { display: flex; justify-content: space-between; padding: 3px 8px; border-bottom: 1px solid #000; font-weight: bold; background: #f2f2f2; }
              .header-title { padding: 5px 8px; font-size: 11px; font-weight: bold; text-align: center; text-transform: uppercase; }
              .header-sub { display: flex; justify-content: space-between; padding: 3px 8px; border-top: 1px solid #000; font-size: 8px; }
              .grid-main { width: 100%; border-collapse: collapse; margin-top: 5px; }
              .grid-main th { background: #f2f2f2; border: 1px solid #000; padding: 4px; font-size: 9px; text-transform: uppercase; }
              .grid-main td { border: 1px solid #000; padding: 3px 5px; font-size: 9px; }
              .footer-summary { margin-top: 5px; font-weight: bold; }
              .summary-table { width: 100%; border-collapse: collapse; border: 1px solid #000; }
              .summary-table td { padding: 4px 5px; background: #f2f2f2; }
              .report-footer { position: fixed; bottom: 0; left: 0; right: 0; border-top: 1px solid #000; padding-top: 4px; display: flex; justify-content: space-between; font-size: 8px; background: #fff; }
              @media print { .no-print { display: none; } body { margin: 0; } .report-footer { position: fixed; bottom: 0; } }
            </style>
          </head>
          <body>
            <div class="report-header">
              <div class="header-top">
                <div>${nomeEmpresa}</div>
                <div>Usuário: ${nomeUsuario}</div>
              </div>
              <div class="header-title">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM SINTÉTICA DE LOTES</div>
              <div class="header-sub">
                <div><strong>Filtros:</strong> Centro: ${this.getLabelFromDropDown('centroEstoquePesquisa', this.CENTRO_ESTOQUE_ID) || 'TODOS'} | Grupo: ${this.getLabelFromDropDown('grupoProdutoPesquisa', this.GRUPO_PRODUTO_ID) || 'TODOS'}</div>
                <div>Emitido em: ${dataHora}</div>
              </div>
            </div>

            <table class="grid-main">
              <thead>
                <tr>
                  <th width="60">CÓDIGO</th>
                  <th>PRODUTO</th>
                  <th width="60">UND COM.</th>
                  <th width="150">CENTRO</th>
                  <th width="100">LOTE</th>
                  <th width="90" align="right">QUANTIDADE</th>
                </tr>
              </thead>
              <tbody>
                ${data.map(l => `
                  <tr>
                    <td align="center">${l.COD_PRO}</td>
                    <td>${l.DESCRICAO}</td>
                    <td align="center">${l.ID_UNIDADE_COMERCIAL || '-'}</td>
                    <td>${l.NOME_CENTRO}</td>
                    <td align="center">${l.LOTE}</td>
                    <td align="right">${tools.formatarQuantidade(l.PESO)}</td>
                  </tr>
                `).join('')}
              </tbody>
              <tfoot>
                <tr style="background: #f2f2f2; font-weight: bold;">
                  <td colspan="5" align="right">TOTAL DE LINHAS: ${data.length} | TOTAIS GERAIS:</td>
                  <td align="right" width="90">${tools.formatarQuantidade(totalPeso)}</td>
                </tr>
              </tfoot>
            </table>

            <div class="report-footer">
              <div>Impresso em: ${dataHora}</div>
              <div style="text-transform: uppercase;">RELATÓRIO DE POSIÇÃO DE ESTOQUE - LISTAGEM SINTÉTICA</div>
              <div>Usuário: ${nomeUsuario}</div>
            </div>
          </body>
          </html>
        `
        RelatorioHTML.imprimir(html, 'Relatório de Posição de Estoque - Sintético', 'A4', 'portrait')
      } catch (error) {
        tools.exibirMensagem(this.$store, 'Erro ao gerar relatório', 'danger', error)
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    }
  },
  
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  }
}
</script>

<style scoped>
.bg-primary-soft { background-color: rgba(32, 168, 216, 0.1); }
.bg-secondary-soft { background-color: rgba(108, 117, 125, 0.1); }
.bg-light-gray { background-color: #f8f9fa; }
.bg-dark-lighter { background-color: #2f353a; }
.bg-dark-darker { background-color: #1e2225; }

.bg-light-rounded {
  background: rgba(0,0,0,0.03); 
  border-radius: 6px;
}

.section-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #ebedef;
  transition: all 0.3s ease;
}

.section-container.dark-mode {
  background: #23282c;
  border-color: #3a4149;
}

.section-container:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  background: #ffffff;
}

.section-container.dark-mode:hover {
  background: #2f353a;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.section-title {
  color: #20a8d8;
  border-bottom: 1px solid #c2cfd6;
  padding-bottom: 8px;
  margin-bottom: 20px;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

.section-title.dark-mode {
  color: #63c2de;
  border-color: #63c2de;
}

.select-premium {
  border: 1px solid #20a8d8;
  color: #20a8d8;
  font-weight: 600;
  cursor: pointer;
}

.btn-generate {
  font-weight: 700;
  letter-spacing: 1px;
  transition: transform 0.2s ease;
}

.btn-generate:hover {
  transform: translateY(-2px);
}

hr {
  border-top: 1px solid #ebedef;
}

hr.border-secondary {
  border-color: #3a4149 !important;
}

.form-group label {
  font-weight: 600;
  color: #4f5d73;
  margin-bottom: 0.5rem;
}

.dark-mode .form-group label {
  color: #c8ced3;
}

.custom-checkbox-label {
  font-size: 1rem;
}

.font-weight-semibold {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/views/relatorios/RelEstoque.vue